import Sonda from '@gc-npm/utils.monitoring.sonda';
import getUUID from '@gc-npm/utils.monitoring.get-uuid';
import Request from '@gc-npm/utils.fetch';
import { calculateHeaderParams } from '@gc-npm/node.build-process.build-environments';
import { FAMILY_API } from '@gc-npm/utils.enums.environment';
import { getRecommendatorAuthHeaders } from '../auth-headers';
import getRecommendatorHost from '../host';

const PATH = '/api/v1/config-controller/recommend-init';
const EVENT_NAME = 'SSR_CONFIG.RECOMMEND_INIT';
const METHOD = 'GET';

export const init = async ({
  context,
  build = false,
  onSuccess,
  idFront = 'TC',
  params,
}) => {
  const idRequest = getUUID(idFront);
  const sonda = new Sonda({
    eventName: EVENT_NAME,
    context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API',
  });

  try {
    const host = getRecommendatorHost({ context });
    let urlParams = '';
    // promo privada
    if (params?.rule) {
      urlParams += `&rule=${params?.rule}`;
    }
    const headers2Use = calculateHeaderParams(build, FAMILY_API.SSR_BACKEND, context);
    const authHeaders = await getRecommendatorAuthHeaders({ context, build });
    // const headers2Use = calculateHeaderParams(build, FAMILY_API.SSR_TVCONFIG, context);

    const URL_API = `${host}${PATH}?${idRequest}${urlParams}`;
    const request = new Request({
      method: METHOD,
      endpoint: URL_API,
      data: '',
      build,
      headers: {
        ...headers2Use,
        ...authHeaders,
      },
      onError: () => {
        return null;
      },
      sonda,
      onSuccess: (response) => {
        return onSuccess({ response });
      },
    });
    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return err;
  }
};
export default init;
